import React, { lazy, useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';

import { useAuth } from '../AuthContext';

const IdleModal = lazy(() => import('../../components/IdleTimeOutModal'));

export default function IdleTimer() {
  const timeout = Number(process.env.REACT_APP_IDLE_TIMEOUT);
  const { authState } = useAuth();
  const [openModal, setOpenModal] = useState(false);
  const [isIdle, setIsIdle] = useState(false);

  const handleOnActive = () => setIsIdle(false);
  const handleOnIdle = () => {
    setIsIdle(true);
    setOpenModal(true);
  };

  const { reset, pause, resume } = useIdleTimer({
    startOnMount: false,
    timeout,
    onActive: handleOnActive,
    onIdle: handleOnIdle,
    stopOnIdle: true
  });

  useEffect(() => {
    if (!isIdle) {
      const loggedIn = authState.isAuthenticated;
      if (loggedIn) {
        reset();
        resume();
      } else {
        pause();
      }
    }
  }, [authState.isAuthenticated, pause, isIdle, resume, reset]);

  return <IdleModal modalIsOpen={openModal} closeModal={() => setOpenModal(false)} />;
}
